import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Droplets01 = function Droplets01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M22 16c0 3.3137-2.6863 6-6 6s-6-2.6863-6-6c0-4.3137 6-14 6-14s6 9.6863 6 14M8 9c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3c0-2.1569 3-7 3-7s3 4.8431 3 7"
    })
  }));
};
export default Droplets01;